<template>
  <p class="hidden">
    Signing out, you will be redirected.
  </p>
</template>

<script>
export default {
  name: 'SignOut',
  created() {
    this.$store.dispatch('session/signOut');
  },
};
</script>

<style lang="scss" scoped>
.hidden {
  display: none;
}
</style>
